import React from 'react'
import Toast from 'antd-mobile/lib/toast'

import 'antd-mobile/lib/toast/style/css'
import './index.scss'

export default class Toast1 extends React.Component {
  static showMessage(msg = '', dur = 4, callback = null, mask = false) {
    Toast.info(msg, dur, callback, mask)
  }
}
